module.exports = __webpack_public_path__ + "企业品牌.png?070f86676e56594536e35a8756e4aac5";


//////////////////
// WEBPACK FOOTER
// ./static/assets/企业品牌.png
// module id = 490
// module chunks = 0